export const getAllGridData = (api) => {
    const rowData = [];
    api.forEachNode((node) => {
        if (!node.group) {
            rowData.push(node.data);
        }
    });
    return rowData;
};
/**
 * Create a context menu for use within an AG Grid
 */
export const createContextMenu = (creator) => {
    return creator;
};
/**
 * Create column defs for a CustomAgTable
 */
export const createColDefs = (colDefs) => {
    return colDefs;
};
/**
 * Create a column def for an AgGridReact
 */
export const createColDef = (colDef) => {
    return colDef;
};
/**
 * Toggle the visibility of some AGGrid columns
 * dependent on which groups are expanded or not
 */
export const toggleColumns = ({ event, columns, rowGroups, }) => {
    if (event.expanded) {
        event.api.setColumnsVisible(columns, true);
        return;
    }
    else {
        const expandedRowIds = event.api.getState().rowGroupExpansion?.expandedRowGroupIds;
        const expandedRows = (expandedRowIds ?? [])
            .map((id) => event.api.getRowNode(id))
            .filter((row) => !!row);
        // 1. Find the field of the row group that was expanded
        const collapsedField = event.node.field;
        rowGroups.forEach((field) => {
            // 2. Find the previous number of open rows of fields in rowGroups
            const numberOfOpenFieldRowGroups = expandedRows.filter((row) => row.field === field).length;
            if (collapsedField === field && numberOfOpenFieldRowGroups === 1) {
                event.api.setColumnsVisible(columns, false);
            }
        });
    }
};
/**
 * Get basic column defs from an array of objects
 */
export const getBasicColDefsFromData = (data) => {
    return Object.keys(data?.[0] ?? {}).map((key) => {
        return {
            field: key,
        };
    });
};
/**
 * A default getRowId function that just gets the id value from a data object.
 */
export const defaultGetRowId = (params) => String(params?.data?.id);
/**
 * From a map of value (number) usually an `_id` --> label (string)
 */
export const valueFormatterFromMap = (map) => {
    return (params) => {
        const value = params.value;
        return map.get(value) ?? value;
    };
};
